
<mat-error *ngIf="control && control.errors && (control.dirty || control.touched)">
    {{getErrorMessage()}}
</mat-error>